<script lang="ts">
	import IKS from "./IKS.svelte";

	export let category = "";
	export let editmode = false;

</script>

<IKS slotHasPadding name={'스토어 형태'} cover={editmode}>
	<img src="/img/icons/placeCategory.png" alt="category Icon" slot="image" />
	<p>{category}</p>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";

	p {
		font-weight: 500;
		color: #46474b;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	@include DesktopSize {
		p {
			font-size: 1.25rem;
		}
	}

</style>
